import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { AuthServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrl: './login-page.component.scss',
    standalone: false
})
export class LoginPageComponent {
  constructor(@Inject(PLATFORM_ID) private platformId: Object,private AuthServiceProxy: AuthServiceProxy) {}
  ngOnInit() {

  }
  login() {
    this.AuthServiceProxy.generateLink(this.getFullUrl()).subscribe((res) => {
      window.location.href = res.url as string;
    });
  }
  getFullUrl() {
    const protocol = window.location.protocol; // Gets 'http:' or 'https:'
    const domainWithPort = window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    const fullUrl = protocol + '//' + domainWithPort;
    return encodeURI(fullUrl);
  }
}
